export interface SuccessToasterState{
    activeToast: boolean,
}

export const state: SuccessToasterState = {
    activeToast: false,
};
